// Klaviyo Reviews Text Formatter
// Transforms "X reviews" text to "(X)" format for product cards

function initKlaviyoReviewsFormatter(widget) {
    function updateReviewsText() {
      const reviewsLabelElement = widget?.querySelector('.kl_reviews__star_rating_widget__label');
      if (reviewsLabelElement && reviewsLabelElement.textContent.includes('review')) {
        const reviewsText = reviewsLabelElement.textContent;
        const numberMatch = reviewsText.match(/\d+/);
        if (numberMatch) {
          const reviewNumber = numberMatch[0];
          reviewsLabelElement.textContent = `(${reviewNumber})`;
          return true;
        }
      }
      return false;
    }
  
    if (!updateReviewsText()) {
      const observer = new MutationObserver(function (mutations) {
        if (updateReviewsText()) {
          observer.disconnect();
        }
      });
  
      if (widget) {
        observer.observe(widget, {
          childList: true,
          subtree: true,
          characterData: true,
        });
  
        // Fallback: stop observing after 5 seconds
        setTimeout(() => observer.disconnect(), 5000);
      }
    }
  }
  
  function initAllKlaviyoWidgets() {
    const widgets = document.querySelectorAll('.klaviyo-star-rating-widget');
    widgets.forEach(widget => {
      initKlaviyoReviewsFormatter(widget);
    });
  }
  
  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllKlaviyoWidgets);
  } else {
    initAllKlaviyoWidgets();
  }
  
  // Also initialize for any dynamically loaded content
  const pageObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          const newWidgets = node.querySelectorAll ? node.querySelectorAll('.klaviyo-star-rating-widget') : [];
          newWidgets.forEach(widget => {
            initKlaviyoReviewsFormatter(widget);
          });
        }
      });
    });
  });
  
  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  